export type LegalBlock = {
  heading?: string;
  paragraphs: string[];
};

export type LegalSection = {
  title?: string;
  blocks: LegalBlock[];
};

export const impressum: LegalSection[] = [
  {
    title: "Angaben gemäß § 5 DDG",
    blocks: [{ paragraphs: ["Bast Medien GmbH", "St. Ulrich Str. 11", "88662 Überlingen"] }],
  },
  {
    title: "Kontakt",
    blocks: [{ paragraphs: ["Telefon: 07551/63320", "E-Mail: eva-maria.bast@bast-medien.de"] }],
  },
  {
    title: "Umsatzsteuer-ID",
    blocks: [
      {
        paragraphs: ["Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz: 87014/00258"],
      },
    ],
  },
  {
    title: "Berufsbezeichnung und berufsrechtliche Regelungen",
    blocks: [{ paragraphs: ["Berufsbezeichnung: Autorin, Coachin", "Verliehen in: Deutschland"] }],
  },
  {
    title: "Verbraucherstreitbeilegung/\u200BUniversalschlichtungsstelle",
    blocks: [
      {
        paragraphs: [
          "Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.",
        ],
      },
    ],
  },
];

export const datenschutz: LegalSection[] = [
  {
    title: "1. Einleitung",
    blocks: [
      {
        paragraphs: [
          "Der Schutz Ihrer persönlichen Daten hat höchste Priorität. Diese Datenschutzerklärung erläutert die Art, den Umfang und den Zweck der Verarbeitung personenbezogener Daten (im Folgenden „Daten“ genannt) in Zusammenhang mit dem Onlineangebot. Dies umfasst die zugehörige Website, Funktionen und Inhalte sowie die externen Onlinepräsenzen, wie beispielsweise die Social-Media-Profile (im Folgenden zusammengefasst als „Onlineangebot“). Ihre personenbezogenen Daten werden vertraulich behandelt und es wird strikt den gesetzlichen Datenschutzvorschriften sowie den Bestimmungen dieser Datenschutzerklärung entsprochen.",
        ],
      },
      {
        heading: "Allgemeine Hinweise",
        paragraphs: [
          "Diese Datenschutzerklärung gibt Ihnen einen umfassenden Überblick darüber, was mit Ihren personenbezogenen Daten geschieht, wenn Sie diese Website besuchen. Personenbezogene Daten sind alle Informationen, die dazu genutzt werden können, Sie persönlich zu identifizieren. Detaillierte Informationen zum Datenschutz entnehmen Sie bitte dieser vollständigen Datenschutzerklärung.",
        ],
      },
      {
        heading: "Verantwortliche Stelle",
        paragraphs: [
          "Die Datenverarbeitung auf dieser Website erfolgt durch den Websitebetreiber. Die Kontaktdaten des Verantwortlichen finden Sie im Abschnitt „Verantwortlicher“ in dieser Datenschutzerklärung.",
        ],
      },
      {
        heading: "Erhebung Ihrer Daten",
        paragraphs: [
          "Personenbezogene Daten werden zum einen dadurch erhoben, dass Sie diese aktiv mitteilen, z. B. durch das Ausfüllen eines Kontaktformulars. Andere Daten werden automatisch oder nach Ihrer Einwilligung beim Besuch der Website durch die IT-Systeme des Verantwortlichen erfasst. Hierbei handelt es sich vor allem um technische Daten (z. B. Internetbrowser, Betriebssystem oder Uhrzeit des Seitenaufrufs). Diese Datenerfassung erfolgt automatisch, sobald Sie die Website betreten.",
        ],
      },
      {
        heading: "Verwendung Ihrer Daten",
        paragraphs: [
          "Ein Teil der Daten wird erhoben, um die fehlerfreie Bereitstellung der Website sicherzustellen. Andere Daten können zur Analyse Ihres Nutzerverhaltens verwendet werden, um das Angebot zu optimieren und auf Ihre Bedürfnisse anzupassen.",
        ],
      },
      {
        heading: "Datenübermittlung an externe Stellen",
        paragraphs: [
          "Im Rahmen der Geschäftstätigkeit des Verantwortlichen kann es erforderlich sein, personenbezogene Daten an externe Stellen zu übermitteln. Diese Übermittlung erfolgt ausschließlich unter bestimmten Bedingungen: wenn die Weitergabe zur Erfüllung eines Vertrags notwendig ist, wenn eine gesetzliche Verpflichtung besteht, beispielsweise an Steuerbehörden, wenn ein berechtigtes Interesse gemäß Art. 6 Abs. 1 lit. f DSGVO vorliegt, oder wenn eine andere rechtliche Grundlage die Datenübermittlung erlaubt.",
          "Beim Einsatz externer Dienstleister zur Datenverarbeitung erfolgt die Weitergabe personenbezogener Daten ausschließlich auf Grundlage eines gültigen Vertrags zur Auftragsverarbeitung gemäß Art. 28 DSGVO. Wenn eine gemeinsame Verarbeitung der Daten mit anderen Stellen stattfindet, wird ein Vertrag über die gemeinsame Verarbeitung gemäß Art. 26 DSGVO abgeschlossen.",
        ],
      },
      {
        heading: "Widerruf von Einwilligungen zur Datenverarbeitung",
        paragraphs: [
          "Bestimmte Datenverarbeitungen können nur mit Ihrer ausdrücklichen Einwilligung erfolgen. Diese Einwilligung kann jederzeit widerrufen werden. Die Rechtmäßigkeit der bis zum Zeitpunkt des Widerrufs erfolgten Datenverarbeitung bleibt durch den Widerruf unberührt.",
        ],
      },
      {
        heading: "Widerspruchsrecht bei spezifischen Datenverarbeitungen und Werbemaßnahmen (Art. 21 DSGVO)",
        paragraphs: [
          "Erfolgt die Verarbeitung Ihrer personenbezogenen Daten auf der Basis von Art. 6 Abs. 1 lit. e oder f DSGVO, haben Sie das Recht, jederzeit gegen diese Verarbeitung Widerspruch einzulegen, sofern Sie Gründe haben, die sich aus Ihrer besonderen Situation ergeben. Dies betrifft auch das Profiling, das auf diesen Bestimmungen basiert. Die konkrete Rechtsgrundlage der Datenverarbeitung finden Sie in dieser Datenschutzerklärung. Bei einem Widerspruch wird der Verantwortliche Ihre personenbezogenen Daten nicht mehr verarbeiten, es sei denn, es können zwingende schutzwürdige Gründe nachgewiesen werden, die Ihre Interessen, Rechte und Freiheiten überwiegen oder die Verarbeitung dient der Geltendmachung, Ausübung oder Verteidigung von Rechtsansprüchen (Widerspruch gemäß Art. 21 Abs. 1 DSGVO).",
          "Werden Ihre personenbezogenen Daten für Zwecke der Direktwerbung genutzt, steht Ihnen das Recht zu, jederzeit Widerspruch gegen diese Verarbeitung einzulegen. Dies gilt auch für das Profiling, sofern es in Verbindung mit Direktwerbung steht. Nach Ihrem Widerspruch wird der Verantwortliche Ihre personenbezogenen Daten nicht mehr für diese Werbezwecke verwenden (Widerspruch gemäß Art. 21 Abs. 2 DSGVO).",
        ],
      },
      {
        heading: "Rechte gemäß Datenschutz-Grundverordnung",
        paragraphs: [
          "Sie haben das Recht, bei Verstößen gegen die DSGVO eine Beschwerde bei einer zuständigen Aufsichtsbehörde einzureichen. Dieses Recht kann insbesondere in dem Mitgliedstaat ausgeübt werden, in dem sich der gewöhnliche Aufenthaltsort, der Arbeitsplatz oder der Ort des mutmaßlichen Verstoßes befindet. Andere verwaltungsrechtliche oder gerichtliche Rechtsbehelfe bleiben hiervon unberührt.",
          "Personenbezogene Daten, die auf Basis einer Einwilligung oder zur Erfüllung eines Vertrags automatisiert verarbeitet werden, können in einem strukturierten, gängigen und maschinenlesbaren Format angefordert werden. Auf Wunsch kann auch eine direkte Übermittlung dieser Daten an einen anderen Verantwortlichen erfolgen, sofern dies technisch möglich ist.",
          "Jede betroffene Person hat das Recht, unentgeltlich Auskunft über ihre gespeicherten personenbezogenen Daten, deren Herkunft, Empfänger sowie den Zweck der Datenverarbeitung zu erhalten. Darüber hinaus besteht ein Recht auf Berichtigung oder Löschung dieser Daten, sofern gesetzliche Bestimmungen dies zulassen. Bei weiteren Fragen oder Anliegen zum Thema personenbezogene Daten kann jederzeit Kontakt mit dem Verantwortlichen aufgenommen werden.",
          "Es besteht das Recht, die Einschränkung der Verarbeitung personenbezogener Daten zu verlangen, wenn die Richtigkeit der Daten bestritten wird und eine Überprüfung aussteht. Auch bei unrechtmäßiger Verarbeitung kann anstelle einer Löschung die Einschränkung der Datenverarbeitung verlangt werden. Weiterhin kann die Einschränkung gefordert werden, wenn die Daten nicht mehr benötigt werden, aber zur Geltendmachung, Ausübung oder Verteidigung von Rechtsansprüchen erforderlich sind. Bei Widerspruch gegen die Verarbeitung gemäß Art. 21 Abs. 1 DSGVO, bis zur Klärung, wessen Interessen überwiegen, besteht ebenfalls das Recht auf Einschränkung.",
          "Sind die personenbezogenen Daten in der Verarbeitung eingeschränkt, dürfen diese, abgesehen von der Speicherung, nur mit Einwilligung der betroffenen Person oder zur Geltendmachung, Ausübung oder Verteidigung von Rechtsansprüchen, zum Schutz der Rechte anderer natürlicher oder juristischer Personen oder aus Gründen eines wichtigen öffentlichen Interesses der EU oder eines Mitgliedstaates verarbeitet werden.",
        ],
      },
    ],
  },
  {
    title: "2. Verantwortlicher",
    blocks: [
      {
        paragraphs: [
          "Verantwortlicher für die Datenverarbeitung auf dieser Website im Sinne der Datenschutz-Grundverordnung (DSGVO) ist:",
          "Eva-Maria Bast\nSt. Ulrich Str. 11\n88662 Überlingen",
          "Website: www.evamariabast.de\nE-Mail: eva-maria.bast@bast-medien.de\nTelefon: 0151/11510224",
        ],
      },
    ],
  },
];
